export default [
    {path: '*', redirect: '/login'},
    {
        path: '/',
        name: 'IndexServizi',
        components: {
            default: () => import('@/views/IndexServizi.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        components: {
            default: () => import('@/views/Login.vue')
        }
    },
    {
        path: '/mapplants/:comune',
        name: 'IndexMapPlants',
        components: {
            default: () => import('@/views/IndexMapPlants.vue'),
            navbar: () => import('@/components/mapplants/Navbar.vue'),
            footer: () => import('@/components/mapplants/Footer.vue')
        }
    },
    {
        path: '/mapplants',
        name: 'IndexMapPlantsSenzaComune',
        components: {
            default: () => import('@/views/IndexMapPlants.vue'),
            navbar: () => import('@/components/mapplants/Navbar.vue'),
            footer: () => import('@/components/mapplants/Footer.vue')
        }
    },
    {
        path: '/report/:comune',
        name: 'IndexReport',
        components: {
            default: () => import('@/views/IndexReport.vue'),
            navbar: () => import('@/components/report/Navbar.vue'),
            footer: () => import('@/components/report/Footer.vue')
        }
    },
    {
        path: '/report',
        name: 'IndexReportSenzaComune',
        components: {
            default: () => import('@/views/IndexReport.vue'),
            navbar: () => import('@/components/report/Navbar.vue'),
            footer: () => import('@/components/report/Footer.vue')
        }
    },
    {
        path: '/report/:comune/admin',
        name: 'IndexReportAdmin',
        components: {
            default: () => import('@/views/IndexReportAdmin.vue'),
            navbar: () => import('@/components/report/Navbar.vue'),
            footer: () => import('@/components/report/Footer.vue')
        },
        meta: {
            requiresOperatoreGestionaleReport: true
        }
    },
    {
        path: '/puntiluce',
        name: 'IndexPuntiLuce',
        components: {
            default: () => import('@/views/IndexPuntiLuce.vue'),
            navbar: () => import('@/components/puntiluce/Navbar.vue')
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/puntiluce/mappa',
        name: 'MappaPuntiLuce',
        components: {
            default: () => import('@/views/IndexPuntiLuceMappa.vue'),
            navbar: () => import('@/components/puntiluce/Navbar.vue'),
            footer: () => import('@/components/puntiluce/Footer.vue')
        }
    }
];
